import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';
import { FormArray } from '@angular/forms';
import { ConfirmationInterruptionsModel, MultilineTextModel, MultilineTextModelOptions } from '@evorait/pace-core';

@Component({
    selector: 'pace-confirmation-interruptions',
    templateUrl: './confirmation-interruptions.component.html',
    styleUrls: ['./confirmation-interruptions.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmationInterruptionsComponent {
    @Input()
    public model: ConfirmationInterruptionsModel;

    @Input()
    public parentForm: FormArray;
    public constructor(private readonly changeDetectorRef: ChangeDetectorRef) {}

    public checkboxClick(affectedTextModel: MultilineTextModel, checkboxValue: boolean): void {
        affectedTextModel.options = new MultilineTextModelOptions({
            ...affectedTextModel.options,
            required: checkboxValue,
        });

        // we need to trigger the change detection for the form validation to occur.
        this.changeDetectorRef.detectChanges();
    }
}
